import styled from 'styled-components';

import { colors, typography } from '../../styles/tokens';

export const Container = styled.footer`
  padding: 56px clamp(20px, 5vw, 96px) 40px;
  border-top: 1px solid ${colors.borderSubtle};
`;

export const Content = styled.div`
  max-width: 1720px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 36px;
`;

export const BrandColumn = styled.div``;

export const Brand = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  img {
    width: 26px;
    height: 26px;
  }

  span {
    font-family: ${typography.displayFontFamily};
    font-weight: 800;
    font-size: 17px;
    letter-spacing: 0.12em;
    color: ${colors.textPrimary};
  }
`;

export const BrandDescription = styled.p`
  margin: 14px 0 0;
  max-width: 260px;
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.textFaintest};
`;

export const Column = styled.div`
  display: grid;
  gap: 10px;
  align-content: start;
  font-size: 15px;

  h4 {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: ${colors.textDisabled};
  }

  a {
    color: ${colors.textFaint};
    transition: color 0.2s;

    &:hover {
      color: ${colors.primary};
    }
  }
`;

export const BottomBar = styled.div`
  max-width: 1720px;
  margin: 40px auto 0;
  padding-top: 24px;
  border-top: 1px solid ${colors.borderSubtle};

  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 14px;

  font-size: 13px;
  color: ${colors.textDisabled};
`;

export const LegalLinks = styled.span`
  display: flex;
  gap: 20px;

  a {
    color: ${colors.textDisabled};
  }
`;
